import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { SlideoverReducerStateIdKeys } from "@/app_redux/reducers/reducer_interface";
import { setSlideoverState } from "@/app_redux/reducers/slideover_reducer";
import { setSlideoverStateData } from "@/app_redux/reducers/slideover_state_reducer";
import { useSlideover } from "./useSlideover";

export const useSlideoverActions = (slideoverId: SlideoverReducerStateIdKeys) => {
  const dispatch = useAppDispatch();
  const slideoverState = useSlideover(slideoverId);
  const setVisible = () => {
    dispatch(
      setSlideoverState({
        key: slideoverId,
        status: true,
      }),
    );
  };

  const setInvisible = () => {
    dispatch(
      setSlideoverState({
        key: slideoverId,
        status: false,
      }),
    );
  };

  const toggle = () => {
    dispatch(
      setSlideoverState({
        key: slideoverId,
        status: !slideoverState,
      }),
    );
  };

  const setSlideoverData = (data: any) => {
    dispatch(
      setSlideoverStateData({
        key: slideoverId,
        data: data,
      }),
    );
  };

  return {
    setVisible,
    setInvisible,
    toggle,
    setSlideoverData,
  };
};
